import React from "react";

export const BagIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33333 14.6668H12.6667C13.402 14.6668 14 14.0688 14 13.3335V6.00016C14 5.82335 13.9298 5.65378 13.8047 5.52876C13.6797 5.40373 13.5101 5.3335 13.3333 5.3335H11.3333V4.66683C11.3333 2.82883 9.838 1.3335 8 1.3335C6.162 1.3335 4.66667 2.82883 4.66667 4.66683V5.3335H2.66667C2.48986 5.3335 2.32029 5.40373 2.19526 5.52876C2.07024 5.65378 2 5.82335 2 6.00016V13.3335C2 14.0688 2.598 14.6668 3.33333 14.6668ZM6 4.66683C6 3.56416 6.89733 2.66683 8 2.66683C9.10267 2.66683 10 3.56416 10 4.66683V5.3335H6V4.66683ZM3.33333 6.66683H4.66667V8.00016H6V6.66683H10V8.00016H11.3333V6.66683H12.6667L12.668 13.3335H3.33333V6.66683Z"
        fill="currentColor"
      />
    </svg>
  );
};
